import { Box, Divider, Stack, Typography } from "@mui/material";
import { CirclePlus } from "lucide-react";

interface NewVehicleBoxProps {
  colorPrimary: string;
  onClick: () => void;
}

export function NewVehicleBox({
  colorPrimary,
  onClick,
}: NewVehicleBoxProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        cursor: "pointer",
        borderRadius: 2,
        maxHeight:10,
        transition: "transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease",
        "&:hover": {
          backgroundColor: `${colorPrimary}10`, // leve highlight
          bgcolor:"transparent",
          transform: "scale(1.05)",
           "&:hover .divider-hover": {
        borderColor: colorPrimary,
        },
        },
      }}
    >   <Stack direction="row" gap={1}  alignItems="start">
          <CirclePlus color={colorPrimary} />
          <Box display="flex" flexDirection="column">
            <Typography
              fontWeight="bold"
              color={colorPrimary}
              fontSize="0.95rem"
            >
              Novo veículo
            </Typography>

            <Divider
            className="divider-hover"
            sx={{
                borderBottomWidth: 2,
                borderColor: "transparent",
                transition: "border-color 0.2s ease",
            }}
            />
          </Box>
        </Stack>
    </Box>
  );
}
